import { DatabaseOutlined } from '@ant-design/icons';
import { useFragmentFromStore } from '@smx-ui-model/hooks/use-fragment-from-store';
import { Button } from 'antd';
import { ReactNode } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import { setCurrentModel } from './store/slices/inspector-slice';

interface LinkToInspectorEntityProps<T> {
    node: any;
    listFieldName?: (keyof T)[];
    icon?: boolean;
    component?: (onClick: (e: any) => void) => ReactNode;
}

export const LinkToInspectorEntity = <T,>({ node, listFieldName, icon, component }: LinkToInspectorEntityProps<T>) => {
    const dispatch = useDispatch();

    // FIXME: any
    const data = useFragmentFromStore(node) as any;

    const onClick = (e: any) => {
        dispatch(setCurrentModel({ key: node.__id, userRef: node }));
        e.stopPropagation();
    };

    return (
        <>
            {component && component(onClick)}

            {icon && !component && (
                <Button
                    type={'link'}
                    icon={<DatabaseOutlined />}
                    onClick={onClick}
                    size={'small'}
                    style={{ marginTop: -1 }}
                />
            )}

            {!icon && !component && (
                <Link to={`#`} onClick={onClick}>
                    {listFieldName?.map((fieldName) => data[fieldName]).join(' ') || node.__id}
                </Link>
            )}
        </>
    );
};
